export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-02-19';

export const dataset = assertValue(
  process.env.NEXT_PUBLIC_SANITY_DATASET,
  'Missing environment variable: NEXT_PUBLIC_SANITY_DATASET'
);

export const projectId = assertValue(
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  'Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID'
);

export const studioUrl = assertValue(
  process.env.NEXT_PUBLIC_SANITY_STUDIO_URL,
  'Missing studio URL variable for preview feature: NEXT_PUBLIC_SANITY_STUDIO_URL'
);

const DATASET_CONFIG: Record<
  string,
  { label: string; color?: string; emoji?: string }
> = {
  production: { label: 'Production', color: '#dc3a2c', emoji: '🚨' },
  staging: { label: 'Test', color: '#24b534', emoji: '✅' },
};

export function getDatasetDisplayName(value: string): string {
  return DATASET_CONFIG[value]?.label ?? value;
}

export function getDatasetConfig(value: string) {
  return DATASET_CONFIG[value];
}

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
